import React from "react";
// import { MessageTable } from "..";
import Application_Header from "./Application_Header";
import ApplicationList from "./ApplicationList";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";

const Application = () => {
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const location = useLocation();

  return (
    <div className="flex min-h-screen">
      {/* Main Content */}
      {!location.pathname.includes("student") && (
        <div className="flex-1 bg-white min-h-screen">
          {/* Desktop Layout */}
          <div className="hidden md:block">
            <div
              className={`transition-all duration-300 ease-in-out ${
                isSideBarOpen ? "ml-80" : "ml-20"
              }`}
            >
              {/* Header Section */}
              <div
                className="p-4 border-b-2 border-gray-300"
                style={{
                  maxWidth: isSideBarOpen
                    ? "calc(100vw - 320px)"
                    : "calc(100vw - 95px)",
                }}
              >
                <Application_Header />
              </div>

              {/* Application List Section */}
              <div
                className="p-4"
                style={{
                  maxWidth: isSideBarOpen
                    ? "calc(100vw - 320px)"
                    : "calc(100vw - 95px)",
                }}
              >
                <ApplicationList />
              </div>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="md:hidden w-full">
            {/* Header Section - Mobile */}
            <div className="p-3 sm:p-4 border-b-2 border-gray-300 w-full">
              <Application_Header />
            </div>

            {/* Application List Section - Mobile */}
            <div className="p-3 sm:p-4 w-full">
              <ApplicationList />
            </div>
          </div>
        </div>
      )}

      {/* Student Routes */}
      {location.pathname.includes("student") && (
        <div className="flex-1 w-full">
          <Outlet />
        </div>
      )}
    </div>
  );
};

export default Application;
